import styled from '@emotion/styled';
import { format as formatDate } from 'date-fns';
import compact from 'lodash/compact';
import sum from 'lodash/sum';
import PropTypes from 'prop-types';
import React from 'react';
import { Box, Flex, Heading, Icon, Text } from '@qga/roo-ui/components';
import { useSelector } from 'react-redux';
import {
  getQueryCheckIn,
  getQueryCheckOut,
  getQueryAdults,
  getQueryChildren,
  getQueryInfants,
  getQueryLocation,
} from 'store/router/routerSelectors';
import { FormatNumber } from 'components/formatters';
import { DISPLAY_DATE_FORMAT } from 'config';
import { SkeletonSummary } from 'components/MapSearchPage/ResultsList/Skeletons';

const BlockText = styled(Text)`
  display: block;
`;

const Divider = () => (
  <Box mx={2} mb={1}>
    <Icon name="circle" color="greys.charcoal" size={4} />
  </Box>
);

const ResultSummary = ({ isLoading }) => {
  const checkIn = useSelector(getQueryCheckIn);
  const checkOut = useSelector(getQueryCheckOut);
  const adults = useSelector(getQueryAdults);
  const children = useSelector(getQueryChildren);
  const infants = useSelector(getQueryInfants);
  const location = useSelector(getQueryLocation);

  const guestCount = sum(compact([adults, children, infants]));

  if (isLoading) {
    return <SkeletonSummary />;
  }

  return (
    <Flex flexDirection="column">
      <Heading.h1 fontSize="lg" mb={0}>
        Hotels in {location}
      </Heading.h1>

      <Flex alignItems="center">
        {checkIn && checkOut && (
          <BlockText data-testid="stay-dates">
            {formatDate(new Date(checkIn), DISPLAY_DATE_FORMAT)} - {formatDate(new Date(checkOut), DISPLAY_DATE_FORMAT)}
          </BlockText>
        )}
        <Divider />
        <BlockText data-testid="guest-count">
          <FormatNumber number={guestCount} />
          {` `}
          {guestCount === 1 ? 'guest' : 'guests'}
        </BlockText>
      </Flex>
    </Flex>
  );
};

ResultSummary.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default ResultSummary;
